<script setup lang="ts">
import { computed } from 'vue'
import { describeError } from '../api/http'
import { displayName } from '../lib/format'
import { useCall } from '../stores/call'
import { useSession } from '../stores/session'
import Avatar from './Avatar.vue'

// A call leaves nothing in the history (presence is the server's), so this shows at the
// end of the chat only while one is running: on a phone the sidebar's LIVE row is hidden.
const props = defineProps<{ conv: string }>()
const session = useSession()
const call = useCall()
const people = computed(() => session.inCall[props.conv] ?? [])
const joinedHere = computed(() => call.conv === props.conv && call.state !== 'idle')

function join(): void {
  call.join(props.conv).catch((e) => session.toast(`Couldn't join the call: ${describeError(e)}`, 'error'))
}
</script>

<template>
  <div v-if="people.length" class="mt-3 flex max-w-md items-center gap-3 border border-border-strong px-3 py-2.5" data-testid="call-card">
    <span class="flex h-9 w-9 shrink-0 items-center justify-center border border-border" aria-hidden="true">
      <span class="h-1.5 w-1.5 animate-blink bg-signal" />
    </span>
    <div class="min-w-0 flex-1">
      <div class="truncate text-sm">Call in progress</div>
      <div class="mono flex min-w-0 items-center gap-1.5 text-text-muted">
        <Avatar v-for="u in people.slice(0, 4)" :key="u" :id="u" :name="displayName(session.profiles, u)" :size="16" />
        <span class="truncate">{{ people.map((u) => displayName(session.profiles, u)).join(', ') }}</span>
      </div>
    </div>
    <span v-if="joinedHere" class="mono text-text-primary uppercase">Joined</span>
    <button v-else class="btn-primary h-7" data-testid="call-join" @click="join">Join</button>
  </div>
</template>
